module.exports = __webpack_public_path__ + "static/media/tag_interactive_popup.64035788.svg";